<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center">POUR SEBASTIAN FOX BLACK,<br/>À PROPOS DE QUI PERSONNE N’A GRAVÉ<br/>DE MESSAGES MENAÇANTS DANS LA GLACE<br/><br/><br/></p>
<p class="center1"><img alt="" src="OEBPS/images/com.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?7dd7cf32